import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SizeTable } from '../SizeTable';
import { SIZE_NOTE } from '../../data/collection';

/** "¿Para qué edad sirve?" — sizes by height with approximate age. */
export function AgesSection() {
  return <section id="talles" aria-labelledby="talles-title" className="w-full bg-ivory-deep" data-id="element-162" data-mp="141pb8lkhwm0y">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-5 py-14 sm:px-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:items-center lg:gap-16 lg:py-20 [&>*]:min-w-0" data-id="element-163" data-mp="z2cqc6d6pp10">
        <div data-id="element-164" data-mp="1rppbcc3p5os7">
          <p className="text-[0.95rem] font-extrabold text-sage-ink" data-id="element-165" data-mp="1rpyzrv93fnvs">¿Para qué edad sirve?</p>
          <div className="mt-2" data-id="element-166" data-mp="1mwmffxbg638u">
            <SectionHeading id="talles-title" title="Talles de recién nacido a 4 años" data-id="element-167" data-mp="1hzdu5nv05j3d" />
          </div>
          <p className="mt-5 hidden max-w-md text-[1rem] leading-relaxed text-graphite-soft lg:block" data-id="element-168" data-mp="2fehz3la60qbq">{SIZE_NOTE}</p>
        </div>
        <div className="mx-auto w-full max-w-lg lg:mx-0" data-id="element-169" data-mp="2an091s9oka5j">
          <SizeTable data-id="element-170" data-mp="10zlxbn97c54f" />
          <p className="mt-4 text-[0.98rem] leading-relaxed text-graphite-soft lg:hidden" data-id="element-171" data-mp="10z3v89zuywol">{SIZE_NOTE}</p>
        </div>
      </div>
    </section>;
}